import script from "./SecondaryFAQs.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondaryFAQs.vue?vue&type=script&setup=true&lang=js"

import "./SecondaryFAQs.vue?vue&type=style&index=0&id=5adfec6a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adfec6a"]])

export default __exports__